var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-list',{attrs:{"title":"Customer List","data-size":"10","data-url":"/api/v1/customer","edit-route":"/master/customer/add","delete-endpoint":"/api/v1/customer","data-headers":_vm.tHeaders}})}
var staticRenderFns = []

export { render, staticRenderFns }